









import { Component, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

// Helpers
import { parseBase64 } from '@/helpers/image'

// Components
import ImageViewerValue from '@/components/common/ImageViewerValue.vue'

// Views
import Field from './Field.vue'

@Component({
  components: { ImageViewerValue }
})
export default class FieldSupport extends Field {
  fullImageIsLoading: boolean = false
  image = new Image()
  galleryReady: boolean = false

  @Getter('proovCode', { namespace: 'report' }) proovCode
  @Getter('token') token
  @Action('updateGallery', { namespace: 'report' }) updateGallery

  @Prop() partID

  get currentValue() {
    return this.position === 'first' ? this.field.picturePath : this.field.dropoffPicturePath
  }

  get fieldLegend() {

    if (this.position === 'first' && !this.field.picturePath && !this.canEditValues) {
      return this.$t('global.field.empty')
    }

    if ((this.position === 'second' && !this.field.dropoffPicturePath && !this.field.picturePath)
      || this.state === 'finished') {
      return this.$t('report.edit.photo.nothing_to_signal')
    }

    return this.$t('report.edit.supports.compare_with_application')
  }

  updateImageSrc(src) {
    this.image.onload = () => {
      this.galleryReady = true
    }
    this.image.src = src
  }
}
